import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getFirestore } from "../../config/firebase";
import "./PromoModal.scss";

/** Colección de info de la marca */
const FIRESTORE_COLLECTION = "peugeot-informacion";
/** Documento dentro de la colección */
const FIRESTORE_DOC = "promo-modal";
/** Clave propia de Peugeot para no pisar el dismiss de otras marcas */
const DISMISS_KEY = "promo-modal-sorteo-mundial-peugeot-dismiss-count";
const MAX_DISMISSES = 2;
const FALLBACK_IMAGE_URL =
  "https://montironiford.com/wp-content/uploads/2026/07/banner-mundial-sin-hb20_sorteo-mundial-promo-modal.webp";

const getDismissCount = () => {
  const raw = localStorage.getItem(DISMISS_KEY);
  const count = Number.parseInt(raw, 10);
  return Number.isFinite(count) && count > 0 ? count : 0;
};

/**
 * Modal promocional dismissable.
 * Flag en Firestore: peugeot-informacion/promo-modal → { mostrar: boolean, imagenUrl?: string }
 * Se oculta de forma permanente recién tras el 2º dismiss.
 */
const PromoModal = () => {
  const [show, setShow] = useState(false);
  const [imageUrl, setImageUrl] = useState(FALLBACK_IMAGE_URL);

  useEffect(() => {
    let cancelled = false;

    const checkAndShow = async () => {
      if (getDismissCount() >= MAX_DISMISSES) return;

      try {
        const db = getFirestore();
        const snap = await db.collection(FIRESTORE_COLLECTION).doc(FIRESTORE_DOC).get();
        if (cancelled || !snap.exists) return;

        const data = snap.data() || {};
        if (data.mostrar !== true) return;

        if (data.imagenUrl) setImageUrl(data.imagenUrl);
        setShow(true);
      } catch (error) {
        if (error?.code !== "cancelled" && error?.message !== "cancelled") {
          console.error("PromoModal: error al leer flag", error);
        }
      }
    };

    checkAndShow();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, String(getDismissCount() + 1));
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      aria-labelledby="promo-modal-sorteo-mundial"
      className="promo-modal"
      dialogClassName="promo-modal-dialog"
    >
      <Modal.Body className="p-0">
        <button
          type="button"
          className="promo-modal-close"
          onClick={handleClose}
          aria-label="Cerrar"
        >
          ×
        </button>
        <img src={imageUrl} alt="Sorteo Mundial Montironi" className="promo-modal-image" />
      </Modal.Body>
    </Modal>
  );
};

export default PromoModal;
